import React from 'react'
import BackButton from './BackButton'

export default function About() {
  return (
    <div className = 'aboutPage'>
      <BackButton/>
      <h3 className = 'title2'>Обо мне.</h3>
      <p className = 'text mb40'>Привет! Меня зовут Артём, и я являюсь full-stack веб-разработчиком, специализирующимся на создании пользовательских веб-сайтов. Моя страсть к созданию красивых и функциональных сайтов началась еще в 14 лет, и с тех пор я никогда не переставал учиться и совершенствоваться в своей области. <br/>
      Я предоставляю услуги веб-разработки уже на протяжении полугода, и за это время я помогаю создавать уникальные и эффективные сайты. Я убежден, что каждый сайт должен быть не только красивым, но и функциональным, чтобы соответствовать целям и потребностям моих клиентов. Кроме того, я постоянно следую за последними тенденциями и новыми технологиями в области веб-разработки, чтобы убедиться, что мои клиенты получают лучшие решения для своих проектов. <br/>
      Я настоящий энтузиаст своей работы, и мне действительно нравится создавать новые и захватывающие проекты. Если вы заинтересованы в сотрудничестве со мной, пожалуйста, свяжитесь со мной, и мы с удовольствием начнем работать вместе.</p>
    </div>
  )
}
